<template>
  <section class="main" id="banner">
    <Header @clicked="toggleModal"/>
    <div class="container-fluid p-t-60" data-aos="fade">
      <div class="container">
        <div class="banner-main flex">
          <div class="banner-main-info">
            <h1 class="banner-main-info-header">
              Turn your Bank into a highly personalized AI-driven interactive app with Zerek.ai
            </h1>
            <span class="banner-main-info-text">
              Connect your data, create rich segments, and engage customers across any channel
            </span>
            <button class="primary show-btn-primary" @click="toggleModal('home')">
              Request Demo
            </button>
          </div>
          <div class="banner-main-slider-container flex flex-row flex-align-items-center">
            <div class="container-images">
              <input type="radio" name="slider" :id="'item-' + (index + 1)"
                     :checked="image.checked"
                     v-bind:key="image.url"
                     v-for="(image, index) in homeImages">
              <div class="container-cards">
                <label class="slider-card flex flex-column"
                       v-for="(image, index) in homeImages"
                       v-bind:key="image.url"
                       :id="'slider-' + (index + 1)"
                       :for="'item-' + (index +1)">
                  <div class="slider-card-img">
                    <img :src="getImagePath(image.url)" alt="slider">
                  </div>
                  <div class="slider-card-info flex flex-row flex-align-items-center flex-justify-content-center mt-22">
                    <div class="slider-card-info-img">
                      <img :src="getImagePath(image.infoUrl)" alt="slider">
                    </div>
                    <p class="slider-card-info-text ml-8">{{image.text}}</p>
                  </div>
                </label>
              </div>
            </div>
          </div>
          <button class="secondary secondary-yellow hide-tablet hide-desktop show-btn-secondary" @click="toggleModal('home')">
            Request Demo
          </button>
        </div>
      </div>
    </div>
  </section>

  <section class="benefits-section container-fluid" id="benefits">
    <div class="container">
      <div class="benefits">
        <div class="benefits-header">
          <div class="benefits-row flex">
            <h2 class="benefits-header-title">Key features</h2>
            <div class="benefits-row-icons flex flex-row flex-align-items-center">
              <i class="benefit-1"
                 :class="{'active': active === 'customerSeg'}"
                 @click="() => makeImageActive('customerSeg')"></i>
              <div class="benefits-box-stepper hide-mobile"></div>
              <i class="benefit-2"
                 :class="{'active': active === 'omnichannel'}"
                 @click="() => makeImageActive('omnichannel')"></i>
              <div class="benefits-box-stepper hide-mobile"></div>
              <i class="benefit-3"
                 :class="{'active': active === 'creativeEditor'}"
                 @click="() => makeImageActive('creativeEditor')"></i>
              <div class="benefits-box-stepper hide-mobile"></div>
              <i class="benefit-4"
                 :class="{'active': active === 'customerData'}"
                 @click="() => makeImageActive('customerData')"></i>
              <div class="benefits-box-stepper hide-mobile"></div>
              <i class="benefit-5"
                 :class="{'active': active === 'aiBanking'}"
                 @click="() => makeImageActive('aiBanking')"></i>
              <div class="benefits-box-stepper hide-mobile"></div>
              <i class="benefit-6"
                 :class="{'active': active === 'analytics'}"
                 @click="() => makeImageActive('analytics')"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="benefits-section-wrapper container-fluid">
    <div class="container">
      <div class="benefits">
        <div class="benefits-wrapper">

          <div class="benefits-boxes" data-aos="fade">
            <div class="benefits-box" ref="customerSeg"
                 :class="{'active': active === 'customerSeg'}">
              <div class="benefits-box-info">
                <h3 class="benefits-box-info-header">
                  Clean-cut segments on top of DWH
                </h3>
                <p class="benefits-box-info-text">
                  Easy-to-use automative segmentation and targeting keeps you steps ahead of customer expectations. Segment your audience and derive service’s specific insights.
                </p>
              </div>
            </div>
            <div class="benefits-box" ref="omnichannel"
                 :class="{'active': active === 'omnichannel'}">
              <div class="benefits-box-info">
                <h3 class="benefits-box-info-header">
                  Omnichannel personalization
                </h3>
                <p class="benefits-box-info-text">
                  Personalize digital world with experiences, reduce product frustration for the customer because it aligns their experience more closely with their perspective.
                </p>
              </div>
            </div>
            <div class="benefits-box" ref="creativeEditor"
                 :class="{'active': active === 'creativeEditor'}">
              <div class="benefits-box-info">
                <h3 class="benefits-box-info-header">
                  Experience studio
                </h3>
                <p class="benefits-box-info-text">
                  Exercise various communication tools with our Marketing SDK. Create advanced and important marketing campaigns via Zerek.ai content types: banners, stories, polls, video-banners, popups, instructions etc
                </p>
              </div>
            </div>
            <div class="benefits-box" ref="customerData"
                 :class="{'active': active === 'customerData'}">
              <div class="benefits-box-info">
                <h3 class="benefits-box-info-header">
                  Customer data platform
                </h3>
                <p class="benefits-box-info-text">
                  Platform combines cross-channel behavioral and transactional data to build unique combination of experiences. This tool offers marketing teams relevant insights needed to run campaigns.
                </p>
              </div>
            </div>
            <div class="benefits-box" ref="aiBanking"
                 :class="{'active': active === 'aiBanking'}">
              <div class="benefits-box-info">
                <h3 class="benefits-box-info-header">
                  AI based recommendation engine
                </h3>
                <p class="benefits-box-info-text">
                  Power your banking system by driving customer loyalty, automate complex processes. Solutions with Big Data capabilities can monitor and store as much information about the bank’s customers as needed, providing the most precise and personalized customer experience.
                </p>
              </div>
            </div>
            <div class="benefits-box" ref="analytics"
                 :class="{'active': active === 'analytics'}">
              <div class="benefits-box-info">
                <h3 class="benefits-box-info-header">
                  Analytics
                </h3>
                <p class="benefits-box-info-text">
                  Comprehensive reporting you can trust. Measure your campaigns using metrics that matter to your team.
                </p>
              </div>
            </div>
          </div>

          <div class="benefits-images">
            <div class="benefits-images-inner" data-aos="fade">
              <div :class="['benefits-image', active === 'customerSeg'? 'active' : '']" ref="customerSegImg">
                <img src="./assets/img/benefits/benefits-slider-0.png" alt="">
              </div>
              <div :class="['benefits-image', active === 'omnichannel'? 'active' : '']" ref="omnichannelImg">
                <img src="./assets/img/benefits/benefits-slider-1.png" alt="">
              </div>
              <div :class="['benefits-image', active === 'creativeEditor'? 'active' : '']" ref="creativeEditorImg">
                <img src="./assets/img/benefits/benefits-slider-2.png" alt="">
              </div>
              <div :class="['benefits-image', active === 'customerData'? 'active' : '']" ref="customerDataImg">
                <img src="./assets/img/benefits/benefits-slider-3.png" alt="">
              </div>
              <div :class="['benefits-image', active === 'aiBanking'? 'active' : '']" ref="aiBankingImg">
                <img src="./assets/img/benefits/benefits-slider-4.png" alt="">
              </div>
              <div :class="['benefits-image', active === 'analytics'? 'active' : '']" ref="analyticsImg">
                <img src="./assets/img/benefits/benefits-slider-5.png" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="value-section container-fluid">
      <div class="value container">
        <div class="t-center">
          <h2 class="value-header">Growing customer value</h2>
          <p class="value-text">Make numbers matter - understand consumers needs</p>
        </div>
        <div class="value-boxes flex flex-row-wrap flex-justify-content-center">
          <div class="value-box t-center" data-aos="fade">
            <i class="engagement"></i>
            <h3 class="value-box-num">3x</h3>
            <h3 class="value-box-title">Engagement</h3>
            <p class="value-box-text">More engaged with the product</p>
          </div>
          <div class="value-box t-center" data-aos="fade">
            <i class="retention"></i>
            <h3 class="value-box-num">1,8x</h3>
            <h3 class="value-box-title">Retention</h3>
            <p class="value-box-text">Higher retention rate</p>
          </div>
          <div class="value-box t-center" data-aos="fade">
            <i class="productivity"></i>
            <h3 class="value-box-num">3x</h3>
            <h3 class="value-box-title">Productivity</h3>
            <p class="value-box-text">More personalized experience delivered</p>
          </div>
          <div class="value-box t-center" data-aos="fade">
            <i class="loyalty"></i>
            <h3 class="value-box-num">70%</h3>
            <h3 class="value-box-title">Loyalty</h3>
            <p class="value-box-text">Order value went up</p>
          </div>
          <div class="value-box t-center" data-aos="fade">
            <i class="revenue"></i>
            <h3 class="value-box-num">1,9x</h3>
            <h3 class="value-box-title">Revenue</h3>
            <p class="value-box-text">More likely to buy additional services</p>
          </div>
          <div class="value-box t-center" data-aos="fade">
            <i class="satisfaction"></i>
            <h3 class="value-box-num">30%</h3>
            <h3 class="value-box-title">Satisfaction</h3>
            <p class="value-box-text">Increase in Net Promoter Score</p>
          </div>
        </div>
      </div>
  </section>

  <section class="platform-section container-fluid" id="platform">
    <div class="container" data-aos="fade">
      <div class="platform flex flex-column flex-align-items-center">
        <h2 class="platform-header">How Platform Works</h2>
        <p class="platform-text">Customer Data Platform Built for Mobile Banks</p>
        <div class="platform-cards platform-cards-top">
          <div class="platform-card brd-blue flex flex-column flex-align-items-center">
            <i class="platform-transactional"></i>
            <h4 class="platform-card-header mt-16 mb-8">Transactional</h4>
            <p class="platform-card-text">way4, oracle, temenos, colvir</p>
            <span class="platform-card-tag animation-desktop" id="tag-date">top_up_amount</span>
          </div>
          <div class="platform-card brd-blue flex flex-column flex-align-items-center">
            <i class="platform-personal"></i>
            <h4 class="platform-card-header mt-16 mb-8">Personal</h4>
            <p class="platform-card-text">sap, unica, pega, netcore</p>
            <span class="platform-card-tag animation-desktop" id="tag-email">customer_email</span>
          </div>
          <div class="platform-card brd-blue flex flex-column flex-align-items-center"
               id="platform-ux">
            <i class="platform-ux"></i>
            <h4 class="platform-card-header mt-16 mb-8">UX data</h4>
            <p class="platform-card-text">yandex, amplitude, uxcam, firebase</p>
            <span class="platform-card-tag animation-desktop" id="tag-code">country_code</span>
          </div>
          <div class="platform-card brd-blue flex flex-column flex-align-items-center"
               id="platform-meta">
            <i class="platform-meta"></i>
            <h4 class="platform-card-header mt-16 mb-8">Meta data</h4>
            <p class="platform-card-text">dictionaries, mdm, acrm</p>
            <span class="platform-card-tag animation-desktop" id="tag-viewed">page_viewed</span>
          </div>
          <div class="platform-card brd-blue flex flex-column flex-align-items-center"
               id="platform-external">
            <i class="platform-external"></i>
            <h4 class="platform-card-header mt-16 mb-8">External data</h4>
            <p class="platform-card-text">mytarget, fbads, google ads</p>
            <span class="platform-card-tag animation-desktop" id="tag-age">loan_offers_visited_count</span>
          </div>
        </div>
        <div class="animation-desktop" v-if="!isAnimationMobile">
          <svg width="1004" height="109" viewBox="0 0 986 109" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M493 109L498.774 99H487.226L493 109ZM0 0V3.25926H2V0H0ZM0 9.77778V16.2963H2V9.77778H0ZM0 22.8148V29.3333H2V22.8148H0ZM0 35.8518V39.1111H2V35.8518H0ZM0 39.1111C0 40.2452 0.111187 41.3543 0.323557 42.4278L2.28553 42.0396C2.09832 41.0933 2 40.1142 2 39.1111H0ZM2.86399 48.5573C4.10483 50.4107 5.70039 52.0063 7.55383 53.2471L8.66647 51.5852C7.03027 50.4898 5.62133 49.0808 4.52592 47.4446L2.86399 48.5573ZM13.6833 55.7876C14.7568 55.9999 15.8659 56.1111 17 56.1111V54.1111C15.9969 54.1111 15.0178 54.0128 14.0715 53.8256L13.6833 55.7876ZM17 56.1111H20.0263V54.1111H17V56.1111ZM26.0789 56.1111H32.1316V54.1111H26.0789V56.1111ZM38.1842 56.1111H44.2368V54.1111H38.1842V56.1111ZM50.2895 56.1111H56.3421V54.1111H50.2895V56.1111ZM62.3947 56.1111H68.4474V54.1111H62.3947V56.1111ZM74.5 56.1111H80.5526V54.1111H74.5V56.1111ZM86.6053 56.1111H92.6579V54.1111H86.6053V56.1111ZM98.7105 56.1111H104.763V54.1111H98.7105V56.1111ZM110.816 56.1111H116.868V54.1111H110.816V56.1111ZM122.921 56.1111H128.974V54.1111H122.921V56.1111ZM135.026 56.1111H141.079V54.1111H135.026V56.1111ZM147.132 56.1111H153.184V54.1111H147.132V56.1111ZM159.237 56.1111H165.289V54.1111H159.237V56.1111ZM171.342 56.1111H177.395V54.1111H171.342V56.1111ZM183.447 56.1111H189.5V54.1111H183.447V56.1111ZM195.553 56.1111H201.605V54.1111H195.553V56.1111ZM207.658 56.1111H213.71V54.1111H207.658V56.1111ZM219.763 56.1111H225.816V54.1111H219.763V56.1111ZM231.868 56.1111H237.921V54.1111H231.868V56.1111ZM243.974 56.1111H247V54.1111H243.974V56.1111ZM492 55.1111V58.4792H494V55.1111H492ZM492 65.2153V71.9514H494V65.2153H492ZM492 78.6875V85.4236H494V78.6875H492ZM492 92.1597V98.8958H494V92.1597H492ZM739 56.1111H742.026V54.1111H739V56.1111ZM748.079 56.1111H754.132V54.1111H748.079V56.1111ZM760.184 56.1111H766.237V54.1111H760.184V56.1111ZM772.289 56.1111H778.342V54.1111H772.289V56.1111ZM784.395 56.1111H790.447V54.1111H784.395V56.1111ZM796.5 56.1111H802.553V54.1111H796.5V56.1111ZM808.605 56.1111H814.658V54.1111H808.605V56.1111ZM820.711 56.1111H826.763V54.1111H820.711V56.1111ZM832.816 56.1111H838.868V54.1111H832.816V56.1111ZM844.921 56.1111H850.974V54.1111H844.921V56.1111ZM857.026 56.1111H863.079V54.1111H857.026V56.1111ZM869.132 56.1111H875.184V54.1111H869.132V56.1111ZM881.237 56.1111H887.289V54.1111H881.237V56.1111ZM893.342 56.1111H899.395V54.1111H893.342V56.1111ZM905.447 56.1111H911.5V54.1111H905.447V56.1111ZM917.553 56.1111H923.605V54.1111H917.553V56.1111ZM929.658 56.1111H935.71V54.1111H929.658V56.1111ZM941.763 56.1111H947.816V54.1111H941.763V56.1111ZM953.868 56.1111H959.921V54.1111H953.868V56.1111ZM965.974 56.1111H969V54.1111H965.974V56.1111ZM969 56.1111C970.134 56.1111 971.243 55.9999 972.317 55.7876L971.929 53.8256C970.982 54.0128 970.003 54.1111 969 54.1111V56.1111ZM978.446 53.2471C980.3 52.0063 981.895 50.4107 983.136 48.5573L981.474 47.4446C980.379 49.0808 978.97 50.4898 977.334 51.5852L978.446 53.2471ZM985.676 42.4278C985.889 41.3543 986 40.2452 986 39.1111H984C984 40.1142 983.902 41.0933 983.714 42.0396L985.676 42.4278ZM986 39.1111V35.8519H984V39.1111H986ZM986 29.3333V22.8148H984V29.3333H986ZM986 16.2963V9.77778H984V16.2963H986ZM986 3.25926V0H984V3.25926H986ZM247 56.1111H249.929V54.1111H247V56.1111ZM255.786 56.1111H261.643V54.1111H255.786V56.1111ZM267.5 56.1111H273.357V54.1111H267.5V56.1111ZM279.214 56.1111H285.071V54.1111H279.214V56.1111ZM290.929 56.1111H296.786V54.1111H290.929V56.1111ZM302.643 56.1111H308.5V54.1111H302.643V56.1111ZM314.357 56.1111H320.214V54.1111H314.357V56.1111ZM326.071 56.1111H331.929V54.1111H326.071V56.1111ZM337.786 56.1111H343.643V54.1111H337.786V56.1111ZM349.5 56.1111H355.357V54.1111H349.5V56.1111ZM361.214 56.1111H367.071V54.1111H361.214V56.1111ZM372.929 56.1111H378.786V54.1111H372.929V56.1111ZM384.643 56.1111H390.5V54.1111H384.643V56.1111ZM396.357 56.1111H402.214V54.1111H396.357V56.1111ZM408.071 56.1111H413.929V54.1111H408.071V56.1111ZM419.786 56.1111H425.643V54.1111H419.786V56.1111ZM431.5 56.1111H437.357V54.1111H431.5V56.1111ZM443.214 56.1111H449.071V54.1111H443.214V56.1111ZM454.929 56.1111H460.786V54.1111H454.929V56.1111ZM466.643 56.1111H472.5V54.1111H466.643V56.1111ZM478.357 56.1111H484.214V54.1111H478.357V56.1111ZM490.071 56.1111H493V54.1111H490.071V56.1111ZM492 0V2.75556H494V0H492ZM492 8.26667V13.7778H494V8.26667H492ZM492 19.2889V24.8H494V19.2889H492ZM492 30.3111V35.8222H494V30.3111H492ZM492 41.3333V46.8444H494V41.3333H492ZM492 52.3556V55.1111H494V52.3556H492ZM493 56.1111H495.929V54.1111H493V56.1111ZM501.786 56.1111H507.643V54.1111H501.786V56.1111ZM513.5 56.1111H519.357V54.1111H513.5V56.1111ZM525.214 56.1111H531.071V54.1111H525.214V56.1111ZM536.929 56.1111H542.786V54.1111H536.929V56.1111ZM548.643 56.1111H554.5V54.1111H548.643V56.1111ZM560.357 56.1111H566.214V54.1111H560.357V56.1111ZM572.071 56.1111H577.929V54.1111H572.071V56.1111ZM583.786 56.1111H589.643V54.1111H583.786V56.1111ZM595.5 56.1111H601.357V54.1111H595.5V56.1111ZM607.214 56.1111H613.071V54.1111H607.214V56.1111ZM618.929 56.1111H624.786V54.1111H618.929V56.1111ZM630.643 56.1111H636.5V54.1111H630.643V56.1111ZM642.357 56.1111H648.214V54.1111H642.357V56.1111ZM654.071 56.1111H659.929V54.1111H654.071V56.1111ZM665.786 56.1111H671.643V54.1111H665.786V56.1111ZM677.5 56.1111H683.357V54.1111H677.5V56.1111ZM689.214 56.1111H695.071V54.1111H689.214V56.1111ZM700.929 56.1111H706.786V54.1111H700.929V56.1111ZM712.643 56.1111H718.5V54.1111H712.643V56.1111ZM724.357 56.1111H730.214V54.1111H724.357V56.1111ZM736.071 56.1111H739V54.1111H736.071V56.1111ZM246 0V2.75556H248V0H246ZM246 8.26667V13.7778H248V8.26667H246ZM246 19.2889V24.8H248V19.2889H246ZM246 30.3111V35.8222H248V30.3111H246ZM246 41.3333V46.8444H248V41.3333H246ZM246 52.3556V55.1111H248V52.3556H246ZM738 0V2.75556H740V0H738ZM738 8.26667V13.7778H740V8.26667H738ZM738 19.2889V24.8H740V19.2889H738ZM738 30.3111V35.8222H740V30.3111H738ZM738 41.3333V46.8444H740V41.3333H738ZM738 52.3556V55.1111H740V52.3556H738Z" fill="white"/>
            <circle
                r="6"
                cy="0"
                cx="1"
                id="dot1"
                style="fill: #ffffff" />
            <path id="curve1" d="M1 0V39.1111C1 47.9477 8.16344 55.1111 17 55.1111H247H493V119" stroke="" stroke-width="2" stroke-linejoin="bevel"/>
            <circle
                r="6"
                cy="0"
                cx="246"
                id="dot2"
                style="fill: #ffffff" />
            <path id="curve2" transform="translate(246, 0)" d="M1 0L1 53.8889L247 53.8889V118.5" stroke="" stroke-width="2" stroke-linejoin="bevel"/>
            <circle
                r="6"
                cy="0"
                cx="492"
                id="dot3"
                style="fill: #ffffff" />
            <path id="curve3" transform="translate(492, 0)" d="M1 0L1 62.3889L1 117.5" stroke="" stroke-width="2" stroke-linejoin="bevel"/>
            <circle
                r="6"
                cy="0"
                cx="738"
                id="dot4"
                style="fill: #ffffff" />
            <path id="curve4" transform="translate(491, 1)" d="M248 0L248 53.8889L2 53.8889L1.5 119" stroke="" stroke-width="2" stroke-linejoin="bevel"/>
            <circle
                r="6"
                cy="0"
                cx="984"
                id="dot5"
                style="fill: #ffffff" />
            <path id="curve5" transform="translate(492, 1)" d="M493 0V37.8889C493 46.7254 485.837 53.8889 477 53.8889L247 53.8889L1 53.8889V119" stroke="" stroke-width="2" stroke-linejoin="bevel"/>
          </svg>
          <div class="platform-logo-frame flex flex-align-items-center flex-justify-content-center">
            <div class="platform-logo">
            </div>
            <svg id="logo" width="214" height="214" viewBox="0 0 214 214" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M212.921 107.249C212.921 48.8882 165.61 1.57739 107.249 1.57739M107.249 212.921C48.888 212.921 1.57715 165.61 1.57715 107.249" stroke="white" stroke-width="1.88913"/>
              <path opacity="0.2" d="M107.249 212.921C165.61 212.921 212.92 165.61 212.92 107.249M1.57697 107.249C1.57697 48.8882 48.8878 1.57739 107.249 1.57739" stroke="#F8C900" stroke-width="1.71667"/>
              <path opacity="0.2" d="M107.249 212.921C165.61 212.921 212.92 165.61 212.92 107.249M1.57697 107.249C1.57697 48.8882 48.8878 1.57739 107.249 1.57739" stroke="#F8C900" stroke-width="1.71667"/>
            </svg>
          </div>
          <svg width="1004" height="110" viewBox="0 0 936 110" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 110L0.226497 100H11.7735L6 110ZM930 110L924.226 100H935.774L930 110ZM312.166 110L306.392 100H317.939L312.166 110ZM620.332 110L614.559 100H626.106L620.332 110ZM5 100.109V93.5156H7V100.109H5ZM5 86.9219V80.3281H7V86.9219H5ZM5 73.7344V70.4375H7V73.7344H5ZM5 70.4375C5 69.3034 5.11119 68.1943 5.32356 67.1208L7.28553 67.509C7.09832 68.4553 7 69.4344 7 70.4375H5ZM7.86399 60.9913C9.10484 59.1379 10.7004 57.5423 12.5538 56.3015L13.6665 57.9634C12.0303 59.0588 10.6213 60.4678 9.52592 62.104L7.86399 60.9913ZM18.6833 53.7611C19.7568 53.5487 20.8659 53.4375 22 53.4375V55.4375C20.9969 55.4375 20.0178 55.5358 19.0715 55.723L18.6833 53.7611ZM22 53.4375H25.0226V55.4375H22V53.4375ZM31.0677 53.4375H37.1128V55.4375H31.0677V53.4375ZM43.1579 53.4375H49.203V55.4375H43.1579V53.4375ZM55.2481 53.4375H61.2933V55.4375H55.2481V53.4375ZM67.3384 53.4375H73.3835V55.4375H67.3384V53.4375ZM79.4286 53.4375H85.4737V55.4375H79.4286V53.4375ZM91.5189 53.4375H97.564V55.4375H91.5189V53.4375ZM103.609 53.4375H109.654V55.4375H103.609V53.4375ZM115.699 53.4375H121.744V55.4375H115.699V53.4375ZM127.79 53.4375H133.835V55.4375H127.79V53.4375ZM139.88 53.4375H145.925V55.4375H139.88V53.4375ZM151.97 53.4375H158.015V55.4375H151.97V53.4375ZM164.06 53.4375H170.105V55.4375H164.06V53.4375ZM176.151 53.4375H182.196V55.4375H176.151V53.4375ZM188.241 53.4375H194.286V55.4375H188.241V53.4375ZM200.331 53.4375H206.376V55.4375H200.331V53.4375ZM212.421 53.4375H218.466V55.4375H212.421V53.4375ZM224.512 53.4375H230.557V55.4375H224.512V53.4375ZM236.602 53.4375H242.647V55.4375H236.602V53.4375ZM248.692 53.4375H254.737V55.4375H248.692V53.4375ZM260.782 53.4375H266.827V55.4375H260.782V53.4375ZM272.872 53.4375H278.918V55.4375H272.872V53.4375ZM284.963 53.4375H291.008V55.4375H284.963V53.4375ZM297.053 53.4375H303.098V55.4375H297.053V53.4375ZM309.143 53.4375H312.166V55.4375H309.143V53.4375ZM467 54.4375V51.7156H469V54.4375H467ZM467 46.2719V40.8281H469V46.2719H467ZM467 35.3844V29.9406H469V35.3844H467ZM467 24.4969V19.0531H469V24.4969H467ZM467 13.6094V8.16563H469V13.6094H467ZM467 2.72188V0H469V2.72188H467ZM620.332 53.4375H623.391V55.4375H620.332V53.4375ZM629.51 53.4375H635.628V55.4375H629.51V53.4375ZM641.746 53.4375H647.864V55.4375H641.746V53.4375ZM653.982 53.4375H660.1V55.4375H653.982V53.4375ZM666.218 53.4375H672.336V55.4375H666.218V53.4375ZM678.454 53.4375H684.572V55.4375H678.454V53.4375ZM690.69 53.4375H696.808V55.4375H690.69V53.4375ZM702.926 53.4375H709.045V55.4375H702.926V53.4375ZM715.163 53.4375H721.281V55.4375H715.163V53.4375ZM727.399 53.4375H733.517V55.4375H727.399V53.4375ZM739.635 53.4375H745.753V55.4375H739.635V53.4375ZM751.871 53.4375H757.989V55.4375H751.871V53.4375ZM764.107 53.4375H770.225V55.4375H764.107V53.4375ZM776.343 53.4375H782.461V55.4375H776.343V53.4375ZM788.579 53.4375H794.698V55.4375H788.579V53.4375ZM800.816 53.4375H806.934V55.4375H800.816V53.4375ZM813.052 53.4375H819.17V55.4375H813.052V53.4375ZM825.288 53.4375H831.406V55.4375H825.288V53.4375ZM837.524 53.4375H843.642V55.4375H837.524V53.4375ZM849.76 53.4375H855.878V55.4375H849.76V53.4375ZM861.996 53.4375H868.114V55.4375H861.996V53.4375ZM874.232 53.4375H880.351V55.4375H874.232V53.4375ZM886.469 53.4375H892.587V55.4375H886.469V53.4375ZM898.705 53.4375H904.823V55.4375H898.705V53.4375ZM910.941 53.4375H914V55.4375H910.941V53.4375ZM914 53.4375C915.134 53.4375 916.243 53.5487 917.317 53.7611L916.929 55.723C915.982 55.5358 915.003 55.4375 914 55.4375V53.4375ZM923.446 56.3015C925.3 57.5423 926.895 59.1379 928.136 60.9913L926.474 62.104C925.379 60.4678 923.97 59.0588 922.334 57.9634L923.446 56.3015ZM930.676 67.1208C930.889 68.1943 931 69.3034 931 70.4375H929C929 69.4344 928.902 68.4553 928.714 67.509L930.676 67.1208ZM931 70.4375V73.7344H929V70.4375H931ZM931 80.3281V86.9219H929V80.3281H931ZM931 93.5156V100.109H929V93.5156H931ZM312.166 53.4375H315.162V55.4375H312.166V53.4375ZM321.156 53.4375H327.15V55.4375H321.156V53.4375ZM333.143 53.4375H339.137V55.4375H333.143V53.4375ZM345.131 53.4375H351.124V55.4375H345.131V53.4375ZM357.118 53.4375H363.112V55.4375H357.118V53.4375ZM369.105 53.4375H375.099V55.4375H369.105V53.4375ZM381.092 53.4375H387.086V55.4375H381.092V53.4375ZM393.08 53.4375H399.073V55.4375H393.08V53.4375ZM405.067 53.4375H411.061V55.4375H405.067V53.4375ZM417.054 53.4375H423.048V55.4375H417.054V53.4375ZM429.041 53.4375H435.035V55.4375H429.041V53.4375ZM441.029 53.4375H447.022V55.4375H441.029V53.4375ZM453.016 53.4375H459.01V55.4375H453.016V53.4375ZM465.003 53.4375H468V55.4375H465.003V53.4375ZM468 53.4375H470.929V55.4375H468V53.4375ZM476.788 53.4375H482.647V55.4375H476.788V53.4375ZM488.506 53.4375H494.365V55.4375H488.506V53.4375ZM500.224 53.4375H506.083V55.4375H500.224V53.4375ZM511.942 53.4375H517.801V55.4375H511.942V53.4375ZM523.66 53.4375H529.519V55.4375H523.66V53.4375ZM535.378 53.4375H541.237V55.4375H535.378V53.4375ZM547.096 53.4375H552.955V55.4375H547.096V53.4375ZM558.814 53.4375H564.673V55.4375H558.814V53.4375ZM570.531 53.4375H576.39V55.4375H570.531V53.4375ZM582.249 53.4375H588.108V55.4375H582.249V53.4375ZM593.967 53.4375H599.826V55.4375H593.967V53.4375ZM605.685 53.4375H611.544V55.4375H605.685V53.4375ZM617.403 53.4375H620.332V55.4375H617.403V53.4375ZM311.166 101.666V96.1094H313.166V101.666H311.166ZM311.166 90.5531V84.9969H313.166V90.5531H311.166ZM311.166 79.4406V73.8844H313.166V79.4406H311.166ZM311.166 68.3281V62.7719H313.166V68.3281H311.166ZM311.166 57.2156V54.4375H313.166V57.2156H311.166ZM619.332 101.666V96.1094H621.332V101.666H619.332ZM619.332 90.5531V84.9969H621.332V90.5531H619.332ZM619.332 79.4406V73.8844H621.332V79.4406H619.332ZM619.332 68.3281V62.7719H621.332V68.3281H619.332ZM619.332 57.2156V54.4375H621.332V57.2156H619.332Z" fill="white"/>
            <circle
                r="6"
                cy="-14"
                cx="468"
                id="dot6"
                style="fill: #ffffff" />
            <circle
                r="6"
                cy="-14"
                cx="468"
                id="dot7"
                style="fill: #ffffff" />
            <circle
                r="6"
                cy="-14"
                cx="467"
                id="dot8"
                style="fill: #ffffff" />
            <circle
                r="6"
                cy="-14"
                cx="467"
                id="dot9"
                style="fill: #ffffff" />
            <path id="curve6" transform="translate(5, 0)" d="M463 0V55.5625L156.834 55.5625L17 55.5625C8.16343 55.5625 1 62.7259 1 71.5625V120" stroke="" stroke-width="2" stroke-linejoin="bevel"/>
            <path id="curve7" transform="translate(311, 0)" d="M157 0V54.4375H79.0829H1.16577V120" stroke="" stroke-width="2" stroke-linejoin="bevel"/>
            <path id="curve8" transform="translate(467, 0)" d="M1 0V54.4375H153.332V120" stroke="" stroke-width="2" stroke-linejoin="bevel"/>
            <path id="curve9" transform="translate(467, 0)" d="M1 0V54.4375H153.332H447C455.837 54.4375 463 61.6009 463 70.4375V120" stroke="" stroke-width="2" stroke-linejoin="bevel"/>
          </svg>
        </div>
        <div class="animation-mobile">
          <svg class="top" width="236" height="226" viewBox="0 0 236 226" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M118 226L120.887 221H115.113L118 226ZM0.5 0V1H1.5V0H0.5ZM0.5 3V5H1.5V3H0.5ZM0.5 7V8H1.5V7H0.5ZM0.5 8C0.5 8.37582 0.524421 8.74618 0.571819 9.10955L1.56342 8.9802C1.5216 8.65961 1.5 8.33245 1.5 8H0.5ZM1.14518 11.2538C1.43185 11.9451 1.80699 12.5902 2.25634 13.1749L3.04926 12.5656C2.65255 12.0494 2.32164 11.4802 2.06891 10.8708L1.14518 11.2538ZM3.82506 14.7437C4.40981 15.193 5.05487 15.5681 5.74617 15.8548L6.12922 14.9311C5.51976 14.6784 4.95064 14.3475 4.43439 13.9507L3.82506 14.7437ZM7.89045 16.4282C8.25382 16.4756 8.62418 16.5 9 16.5V15.5C8.66754 15.5 8.34039 15.4784 8.0198 15.4366L7.89045 16.4282ZM9 16.5H10.0347V15.5H9V16.5ZM12.1042 16.5H14.1736V15.5H12.1042V16.5ZM16.2431 16.5H18.3125V15.5H16.2431V16.5ZM20.3819 16.5H22.4514V15.5H20.3819V16.5ZM24.5208 16.5H26.5903V15.5H24.5208V16.5ZM28.6597 16.5H30.7292V15.5H28.6597V16.5ZM32.7986 16.5H34.8681V15.5H32.7986V16.5ZM36.9375 16.5H39.0069V15.5H36.9375V16.5ZM41.0764 16.5H43.1458V15.5H41.0764V16.5ZM45.2153 16.5H46.25V15.5H45.2153V16.5ZM46.25 16.5H47.2465V15.5H46.25V16.5ZM49.2396 16.5H51.2326V15.5H49.2396V16.5ZM53.2257 16.5H55.2188V15.5H53.2257V16.5ZM57.2118 16.5H59.2049V15.5H57.2118V16.5ZM61.1979 16.5H63.191V15.5H61.1979V16.5ZM65.184 16.5H67.1771V15.5H65.184V16.5ZM69.1701 16.5H71.1632V15.5H69.1701V16.5ZM73.1562 16.5H75.1493V15.5H73.1562V16.5ZM77.1424 16.5H79.1354V15.5H77.1424V16.5ZM81.1285 16.5H83.1215V15.5H81.1285V16.5ZM85.1146 16.5H87.1076V15.5H85.1146V16.5ZM89.1007 16.5H91.0938V15.5H89.1007V16.5ZM93.0868 16.5H95.0799V15.5H93.0868V16.5ZM97.0729 16.5H99.066V15.5H97.0729V16.5ZM101.059 16.5H103.052V15.5H101.059V16.5ZM105.045 16.5H107.038V15.5H105.045V16.5ZM109.031 16.5H111.024V15.5H109.031V16.5ZM113.017 16.5H115.01V15.5H113.017V16.5ZM117.004 16.5H118V15.5H117.004V16.5ZM117.5 16V16.9906H118.5V16H117.5ZM117.5 18.9717V20.9528H118.5V18.9717H117.5ZM117.5 22.934V24.9151H118.5V22.934H117.5ZM117.5 26.8962V28.8774H118.5V26.8962H117.5ZM117.5 30.8585V32.8396H118.5V30.8585H117.5ZM117.5 34.8208V36.8019H118.5V34.8208H117.5ZM117.5 38.783V40.7642H118.5V38.783H117.5ZM117.5 42.7453V44.7264H118.5V42.7453H117.5ZM117.5 46.7076V48.6887H118.5V46.7076H117.5ZM117.5 50.6698V52.6509H118.5V50.6698H117.5ZM117.5 54.6321V56.6132H118.5V54.6321H117.5ZM117.5 58.5943V60.5755H118.5V58.5943H117.5ZM117.5 62.5566V64.5377H118.5V62.5566H117.5ZM117.5 66.5189V68.5H118.5V66.5189H117.5ZM117.5 70.4811V72.4623H118.5V70.4811H117.5ZM117.5 74.4434V76.4245H118.5V74.4434H117.5ZM117.5 78.4057V80.3868H118.5V78.4057H117.5ZM117.5 82.3679V84.3491H118.5V82.3679H117.5ZM117.5 86.3302V88.3113H118.5V86.3302H117.5ZM117.5 90.2925V92.2736H118.5V90.2925H117.5ZM117.5 94.2547V96.2359H118.5V94.2547H117.5ZM117.5 98.217V100.198H118.5V98.217H117.5ZM117.5 102.179V104.16H118.5V102.179H117.5ZM117.5 106.142V108.123H118.5V106.142H117.5ZM117.5 110.104V112.085H118.5V110.104H117.5ZM117.5 114.066V116.047H118.5V114.066H117.5ZM117.5 118.028V120.009H118.5V118.028H117.5ZM117.5 121.991V123.972H118.5V121.991H117.5ZM117.5 125.953V127.934H118.5V125.953H117.5ZM117.5 129.915V131.896H118.5V129.915H117.5ZM117.5 133.877V135.859H118.5V133.877H117.5ZM117.5 137.84V139.821H118.5V137.84H117.5ZM117.5 141.802V143.783H118.5V141.802H117.5ZM117.5 145.764V147.745H118.5V145.764H117.5ZM117.5 149.726V151.708H118.5V149.726H117.5ZM117.5 153.689V155.67H118.5V153.689H117.5ZM117.5 157.651V159.632H118.5V157.651H117.5ZM117.5 161.613V163.594H118.5V161.613H117.5ZM117.5 165.575V167.557H118.5V165.575H117.5ZM117.5 169.538V171.519H118.5V169.538H117.5ZM117.5 173.5V175.481H118.5V173.5H117.5ZM117.5 177.462V179.443H118.5V177.462H117.5ZM117.5 181.424V183.406H118.5V181.424H117.5ZM117.5 185.387V187.368H118.5V185.387H117.5ZM117.5 189.349V191.33H118.5V189.349H117.5ZM117.5 193.311V195.292H118.5V193.311H117.5ZM117.5 197.273V199.255H118.5V197.273H117.5ZM117.5 201.236V203.217H118.5V201.236H117.5ZM117.5 205.198V207.179H118.5V205.198H117.5ZM117.5 209.16V211.141H118.5V209.16H117.5ZM117.5 213.122V215.104H118.5V213.122H117.5ZM117.5 217.085V219.066H118.5V217.085H117.5ZM117.5 221.047V223.028H118.5V221.047H117.5ZM118 16.5H118.997V15.5H118V16.5ZM120.99 16.5H122.983V15.5H120.99V16.5ZM124.976 16.5H126.969V15.5H124.976V16.5ZM128.962 16.5H130.955V15.5H128.962V16.5ZM132.948 16.5H134.941V15.5H132.948V16.5ZM136.934 16.5H138.927V15.5H136.934V16.5ZM140.92 16.5H142.913V15.5H140.92V16.5ZM144.906 16.5H146.899V15.5H144.906V16.5ZM148.892 16.5H150.885V15.5H148.892V16.5ZM152.878 16.5H154.872V15.5H152.878V16.5ZM156.865 16.5H158.858V15.5H156.865V16.5ZM160.851 16.5H162.844V15.5H160.851V16.5ZM164.837 16.5H166.83V15.5H164.837V16.5ZM168.823 16.5H170.816V15.5H168.823V16.5ZM172.809 16.5H174.802V15.5H172.809V16.5ZM176.795 16.5H178.788V15.5H176.795V16.5ZM180.781 16.5H182.774V15.5H180.781V16.5ZM184.767 16.5H186.76V15.5H184.767V16.5ZM188.754 16.5H189.75V15.5H188.754V16.5ZM189.75 16.5H190.785V15.5H189.75V16.5ZM192.854 16.5H194.924V15.5H192.854V16.5ZM196.993 16.5H199.062V15.5H196.993V16.5ZM201.132 16.5H203.201V15.5H201.132V16.5ZM205.271 16.5H207.34V15.5H205.271V16.5ZM209.41 16.5H211.479V15.5H209.41V16.5ZM213.549 16.5H215.618V15.5H213.549V16.5ZM217.688 16.5H219.757V15.5H217.688V16.5ZM221.826 16.5H223.896V15.5H221.826V16.5ZM225.965 16.5H227V15.5H225.965V16.5ZM227 16.5C227.376 16.5 227.746 16.4756 228.11 16.4282L227.98 15.4366C227.66 15.4784 227.332 15.5 227 15.5V16.5ZM230.254 15.8548C230.945 15.5681 231.59 15.193 232.175 14.7437L231.566 13.9507C231.049 14.3474 230.48 14.6784 229.871 14.9311L230.254 15.8548ZM233.744 13.1749C234.193 12.5902 234.568 11.9451 234.855 11.2538L233.931 10.8708C233.678 11.4802 233.347 12.0494 232.951 12.5656L233.744 13.1749ZM235.428 9.10955C235.476 8.74618 235.5 8.37582 235.5 8H234.5C234.5 8.33245 234.478 8.65961 234.437 8.9802L235.428 9.10955ZM235.5 8V7H234.5V8H235.5ZM235.5 5V3H234.5V5H235.5ZM235.5 1V0H234.5V1H235.5ZM117.5 0V1H118.5V0H117.5ZM117.5 3V5H118.5V3H117.5ZM117.5 7V9H118.5V7H117.5ZM117.5 11V13H118.5V11H117.5ZM117.5 15V16H118.5V15H117.5ZM50.5 186V187H51.5V186H50.5ZM50.5 189V191H51.5V189H50.5ZM50.5 193V194H51.5V193H50.5ZM50.5 194C50.5 194.376 50.5244 194.746 50.5718 195.11L51.5634 194.98C51.5216 194.66 51.5 194.332 51.5 194H50.5ZM51.1452 197.254C51.4319 197.945 51.807 198.59 52.2563 199.175L53.0493 198.566C52.6525 198.049 52.3216 197.48 52.0689 196.871L51.1452 197.254ZM53.8251 200.744C54.4098 201.193 55.0549 201.568 55.7462 201.855L56.1292 200.931C55.5198 200.678 54.9506 200.347 54.4344 199.951L53.8251 200.744ZM57.8905 202.428C58.2538 202.476 58.6242 202.5 59 202.5V201.5C58.6675 201.5 58.3404 201.478 58.0198 201.437L57.8905 202.428ZM59 202.5H59.9833V201.5H59V202.5ZM61.95 202.5H63.9167V201.5H61.95V202.5ZM65.8833 202.5H67.85V201.5H65.8833V202.5ZM69.8167 202.5H71.7833V201.5H69.8167V202.5ZM73.75 202.5H75.7167V201.5H73.75V202.5ZM77.6833 202.5H79.65V201.5H77.6833V202.5ZM81.6167 202.5H83.5833V201.5H81.6167V202.5ZM85.55 202.5H87.5167V201.5H85.55V202.5ZM89.4833 202.5H91.45V201.5H89.4833V202.5ZM93.4167 202.5H95.3833V201.5H93.4167V202.5ZM97.35 202.5H99.3167V201.5H97.35V202.5ZM101.283 202.5H103.25V201.5H101.283V202.5ZM105.217 202.5H107.183V201.5H105.217V202.5ZM109.15 202.5H111.117V201.5H109.15V202.5ZM113.083 202.5H115.05V201.5H113.083V202.5ZM117.017 202.5H118V201.5H117.017V202.5ZM118 202.5H118.983V201.5H118V202.5ZM120.95 202.5H122.917V201.5H120.95V202.5ZM124.883 202.5H126.85V201.5H124.883V202.5ZM128.817 202.5H130.783V201.5H128.817V202.5ZM132.75 202.5H134.717V201.5H132.75V202.5ZM136.683 202.5H138.65V201.5H136.683V202.5ZM140.617 202.5H142.583V201.5H140.617V202.5ZM144.55 202.5H146.517V201.5H144.55V202.5ZM148.483 202.5H150.45V201.5H148.483V202.5ZM152.417 202.5H154.383V201.5H152.417V202.5ZM156.35 202.5H158.317V201.5H156.35V202.5ZM160.283 202.5H162.25V201.5H160.283V202.5ZM164.217 202.5H166.183V201.5H164.217V202.5ZM168.15 202.5H170.117V201.5H168.15V202.5ZM172.083 202.5H174.05V201.5H172.083V202.5ZM176.017 202.5H177V201.5H176.017V202.5ZM177 202.5C177.376 202.5 177.746 202.476 178.11 202.428L177.98 201.437C177.66 201.478 177.332 201.5 177 201.5V202.5ZM180.254 201.855C180.945 201.568 181.59 201.193 182.175 200.744L181.566 199.951C181.049 200.347 180.48 200.678 179.871 200.931L180.254 201.855ZM183.744 199.175C184.193 198.59 184.568 197.945 184.855 197.254L183.931 196.871C183.678 197.48 183.347 198.049 182.951 198.566L183.744 199.175ZM185.428 195.11C185.476 194.746 185.5 194.376 185.5 194H184.5C184.5 194.332 184.478 194.66 184.437 194.98L185.428 195.11ZM185.5 194V193H184.5V194H185.5ZM185.5 191V189H184.5V191H185.5ZM185.5 187V186H184.5V187H185.5Z" fill="white"/>
            <circle
                r="6"
                cy="3"
                cx="0"
                id="dot1"
                style="fill: #ffffff" />
            <circle
                r="6"
                cy="3"
                cx="118"
                id="dot2"
                style="fill: #ffffff" />
            <circle
                r="6"
                cy="3"
                cx="234"
                id="dot3"
                style="fill: #ffffff" />
            <circle
                r="6"
                cy="186"
                cx="50"
                id="dot4"
                style="fill: #ffffff" />
            <circle
                r="6"
                cy="186"
                cx="185"
                id="dot5"
                style="fill: #ffffff" />
            <path id="curve1" transform="translate(0, 0)" d="M1 0V8C1 12.4183 4.58172 16 9 16H46.25H110C114.418 16 118 19.5817 118 24V236" stroke-linejoin="bevel"/>
            <path id="curve2" transform="translate(115, 0)" d="M1 0L1 220L1 236" stroke="" stroke-linejoin="bevel"/>
            <path id="curve3" transform="translate(115, 0)" d="M118 0V7.32203C118 11.7403 114.418 15.322 110 15.322H72.75H9C4.58172 15.322 1 18.9038 1 23.322V236" stroke="" stroke-linejoin="bevel"/>
            <path id="curve4" transform="translate(50, 186)" d="M1 0V8C1 12.4183 4.58172 16 9 16L60 16C64.4183 16 68 19.5817 68 24V50" stroke="" stroke-linejoin="bevel"/>
            <path id="curve5" transform="translate(115, 186)" d="M68 0V8C68 12.4183 64.4183 16 60 16L9 16C4.58172 16 1 19.5817 1 24V50" stroke="" stroke-linejoin="bevel"/>
          </svg>
          <div class="platform-logo-frame flex flex-align-items-center flex-justify-content-center">
            <div class="platform-logo-mobile">
            </div>
            <svg id="logo" width="132" height="132" viewBox="0 0 132 132" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M130.664 66.0589C130.664 30.2249 101.615 1.17578 65.7812 1.17578M65.7812 130.942C29.9473 130.942 0.898132 101.893 0.898132 66.0589" stroke="white" stroke-width="1.15994"/>
              <path opacity="0.2" d="M65.7812 130.942C101.615 130.942 130.664 101.893 130.664 66.0589M0.898117 66.0589C0.898119 30.2249 29.9473 1.17578 65.7812 1.17578" stroke="#F8C900" stroke-width="0.5"/>
            </svg>
          </div>
          <svg class="bottom" width="30" height="330" viewBox="0 0 30 324" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 120.696L5 123.583V117.809L0 120.696ZM30 120.696L25 117.809V123.583L30 120.696ZM0 321L5 323.887V318.113L0 321ZM30 321L25 318.113V323.887L30 321ZM14.5 0V1.00312H15.5V0H14.5ZM14.5 3.00937V5.01562H15.5V3.00937H14.5ZM14.5 7.02187V9.02812H15.5V7.02187H14.5ZM14.5 11.0344V13.0406H15.5V11.0344H14.5ZM14.5 15.0469V17.0531H15.5V15.0469H14.5ZM14.5 19.0594V21.0656H15.5V19.0594H14.5ZM14.5 23.0719V25.0781H15.5V23.0719H14.5ZM14.5 27.0844V29.0906H15.5V27.0844H14.5ZM14.5 31.0969V33.1031H15.5V31.0969H14.5ZM14.5 35.1094V37.1156H15.5V35.1094H14.5ZM14.5 39.1219V41.1281H15.5V39.1219H14.5ZM14.5 43.1344V45.1406H15.5V43.1344H14.5ZM14.5 47.1469V49.1531H15.5V47.1469H14.5ZM14.5 51.1594V53.1656H15.5V51.1594H14.5ZM14.5 55.1719V57.1781H15.5V55.1719H14.5ZM14.5 59.1844V61.1906H15.5V59.1844H14.5ZM14.5 63.1969V65.2031H15.5V63.1969H14.5ZM14.5 67.2093V69.2156H15.5V67.2093H14.5ZM14.5 71.2218V73.2281H15.5V71.2218H14.5ZM14.5 75.2343V77.2406H15.5V75.2343H14.5ZM14.5 79.2468V81.2531H15.5V79.2468H14.5ZM14.5 83.2593V85.2656H15.5V83.2593H14.5ZM14.5 87.2718V89.2781H15.5V87.2718H14.5ZM14.5 91.2843V93.2906H15.5V91.2843H14.5ZM14.5 95.2968V97.3031H15.5V95.2968H14.5ZM14.5 99.3093V101.316H15.5V99.3093H14.5ZM14.5 103.322V105.328H15.5V103.322H14.5ZM14.5 107.334V109.341H15.5V107.334H14.5ZM14.5 111.347V113.353H15.5V111.347H14.5ZM14.5 115.359V117.366H15.5V115.359H14.5ZM14.5 119.372V121.378H15.5V119.372H14.5ZM14.5 123.384V125.391H15.5V123.384H14.5ZM14.5 127.397V129.403H15.5V127.397H14.5ZM14.5 131.409V133.416H15.5V131.409H14.5ZM14.5 135.422V137.428H15.5V135.422H14.5ZM14.5 139.434V141.441H15.5V139.434H14.5ZM14.5 143.447V145.453H15.5V143.447H14.5ZM14.5 147.459V149.466H15.5V147.459H14.5ZM14.5 151.472V153.478H15.5V151.472H14.5ZM14.5 155.484V157.491H15.5V155.484H14.5ZM14.5 159.497V161.503H15.5V159.497H14.5ZM14.5 163.509V165.516H15.5V163.509H14.5ZM14.5 167.522V169.528H15.5V167.522H14.5ZM14.5 171.534V173.541H15.5V171.534H14.5ZM14.5 175.547V177.553H15.5V175.547H14.5ZM14.5 179.559V181.566H15.5V179.559H14.5ZM14.5 183.572V185.578H15.5V183.572H14.5ZM14.5 187.584V189.591H15.5V187.584H14.5ZM14.5 191.597V193.603H15.5V191.597H14.5ZM14.5 195.61V197.616H15.5V195.61H14.5ZM14.5 199.622V201.628H15.5V199.622H14.5ZM14.5 203.635V205.641H15.5V203.635H14.5ZM14.5 207.647V209.653H15.5V207.647H14.5ZM14.5 211.66V213.666H15.5V211.66H14.5ZM14.5 215.672V217.678H15.5V215.672H14.5ZM14.5 219.685V221.691H15.5V219.685H14.5ZM14.5 223.697V225.703H15.5V223.697H14.5ZM14.5 227.71V229.716H15.5V227.71H14.5ZM14.5 231.722V233.728H15.5V231.722H14.5ZM14.5 235.735V237.741H15.5V235.735H14.5ZM14.5 239.747V241.753H15.5V239.747H14.5ZM14.5 243.76V245.766H15.5V243.76H14.5ZM14.5 247.772V249.778H15.5V247.772H14.5ZM14.5 251.785V253.791H15.5V251.785H14.5ZM14.5 255.797V257.803H15.5V255.797H14.5ZM14.5 259.81V261.816H15.5V259.81H14.5ZM14.5 263.822V265.828H15.5V263.822H14.5ZM14.5 267.835V269.841H15.5V267.835H14.5ZM14.5 271.847V273.853H15.5V271.847H14.5ZM14.5 275.86V277.866H15.5V275.86H14.5ZM14.5 279.872V281.879H15.5V279.872H14.5ZM14.5 283.885V285.891H15.5V283.885H14.5ZM14.5 287.897V289.904H15.5V287.897H14.5ZM14.5 291.91V293.916H15.5V291.91H14.5ZM14.5 295.922V297.929H15.5V295.922H14.5ZM14.5 299.935V301.941H15.5V299.935H14.5ZM14.5 303.947V305.954H15.5V303.947H14.5ZM14.5 307.96V309.966H15.5V307.96H14.5ZM14.5 311.972V313.979H15.5V311.972H14.5ZM14.5 315.985V317.991H15.5V315.985H14.5ZM14.5 319.997V321H15.5V319.997H14.5ZM2.8125 321.5H4.6875V320.5H2.8125V321.5ZM6.5625 321.5H8.4375V320.5H6.5625V321.5ZM10.3125 321.5H12.1875V320.5H10.3125V321.5ZM14.0625 321.5H15V320.5H14.0625V321.5ZM15 321.5H15.9375V320.5H15V321.5ZM17.8125 321.5H19.6875V320.5H17.8125V321.5ZM21.5625 321.5H23.4375V320.5H21.5625V321.5ZM25.3125 321.5H27.1875V320.5H25.3125V321.5ZM2.8125 121.196H4.6875V120.196H2.8125V121.196ZM6.5625 121.196H8.4375V120.196H6.5625V121.196ZM10.3125 121.196H12.1875V120.196H10.3125V121.196ZM14.0625 121.196H15V120.196H14.0625V121.196ZM15 121.196H15.9375V120.196H15V121.196ZM17.8125 121.196H19.6875V120.196H17.8125V121.196ZM21.5625 121.196H23.4375V120.196H21.5625V121.196ZM25.3125 121.196H27.1875V120.196H25.3125V121.196Z" fill="white"/>
            <circle
                r="6"
                cy="-14"
                cx="-7"
                id="dot6"
                style="fill: #ffffff" />
            <circle
                r="6"
                cy="-14"
                cx="15"
                id="dot7"
                style="fill: #ffffff" />
            <circle
                r="6"
                cy="-14"
                cx="-7"
                id="dot8"
                style="fill: #ffffff" />
            <circle
                r="6"
                cy="-14"
                cx="14"
                id="dot9"
                style="fill: #ffffff" />
            <path id="curve6" transform="translate(-8, 0)" d="M22 0V112.696C22 117.114 18.4183 120.696 14 120.696H0" stroke="" stroke-linejoin="bevel"/>
            <path id="curve7" transform="translate(14, 0)" d="M1 0V113.196C1 117.338 4.35786 120.696 8.5 120.696V120.696H23.5" stroke=""/>
            <path id="curve8" transform="translate(-7, 0)" d="M22 0V313C22 317.418 18.4183 321 14 321H0" stroke=""/>
            <path id="curve9" transform="translate(14, 0)" d="M1 0V313C1 317.418 4.58172 321 9 321H23" stroke=""/>
          </svg>
        </div>

        <div class="platform-cards platform-cards-bottom">
          <div class="platform-card brd-yellow platform-card-bottom flex flex-column flex-align-items-center">
            <i class="platform-engine"></i>
            <h4 class="platform-card-header platform-card-header-lg mt-22 mb-8">Personalization engine</h4>
            <p class="platform-card-text platform-card-text-lg">Real-time event driven personalized marketing campaigns</p>
          </div>
          <div class="platform-card brd-yellow platform-card-bottom flex flex-column flex-align-items-center">
            <i class="platform-analytics"></i>
            <h4 class="platform-card-header platform-card-header-lg mt-22 mb-8">Analytics and insights</h4>
            <p class="platform-card-text platform-card-text-lg">Advanced analytics to enhance data-driven operations</p>
          </div>
          <div class="platform-card brd-yellow platform-card-bottom flex flex-column flex-align-items-center"
               id="platform-event">
            <i class="platform-event"></i>
            <h4 class="platform-card-header platform-card-header-lg mt-22 mb-8">Event machine and ML scripts autorun</h4>
            <p class="platform-card-text platform-card-text-lg">Сollection, analysis and transfer to BI systems</p>
          </div>
          <div class="platform-card brd-yellow platform-card-bottom flex flex-column flex-align-items-center"
               id="platform-channel">
            <i class="platform-channel mt-22 mb-8"></i>
            <h4 class="platform-card-header platform-card-header-lg">Channel Management</h4>
            <p class="platform-card-text platform-card-text-lg">In-app banners, SMS, Stories, email, ATM, TV, fb ads etc.</p>
          </div>
        </div>
      </div>

    </div>
  </section>


  <section class="cases-section container-fluid" id="use-cases">
    <div class="container" data-aos="fade">
      <div class="cases">
        <h2 class="cases-header t-center">Use cases</h2>
        <p class="cases-text t-center">Take advantage of users’ habits, improve and educate with time, not straight away</p>
        <div class="hide-tablet hide-desktop">
          <div class="cases-titles flex flex-row-wrap flex-justify-content-center mt-12">
            <div :class="['cases-titles-btn', activeCase === 0 ? 'active' : '']" @click="activateCase(0, 'up_cross')">
              <p>Up sell & cross sell</p>
            </div>
            <div :class="['cases-titles-btn', activeCase === 1 ? 'active' : '']" @click="activateCase(1, 'motivational')">
              <p>Motivational marketing & Gamification</p>
            </div>
            <div :class="['cases-titles-btn', activeCase === 2 ? 'active' : '']" @click="activateCase(2, 'onboarding')">
              <p>Onboarding on new service</p>
            </div>
            <div :class="['cases-titles-btn', activeCase === 3 ? 'active' : '']" @click="activateCase(3, 'instructions')">
              <p>Instructions “How to”</p>
            </div>
            <div :class="['cases-titles-btn', activeCase === 4 ? 'active' : '']" @click="activateCase(4, 'polls')">
              <p>Polls</p>
            </div>
          </div>
        </div>
        <div class="cases-main flex flex-justify-content-space-between">
          <div class="cases-titles hide-mobile">
            <div :class="['cases-titles-btn', activeCase === 0 ? 'active' : '']" @click="activateCase(0, 'up_cross')">
              <p>Up sell & cross sell</p>
            </div>
            <div :class="['cases-titles-btn', activeCase === 1 ? 'active' : '']" @click="activateCase(1, 'motivational')">
              <p>Motivational marketing & Gamification</p>
            </div>
            <div :class="['cases-titles-btn', activeCase === 2 ? 'active' : '']" @click="activateCase(2, 'onboarding')">
              <p>Onboarding on new service</p>
            </div>
            <div :class="['cases-titles-btn', activeCase === 3 ? 'active' : '']" @click="activateCase(3, 'instructions')">
              <p>Instructions “How to”</p>
            </div>
            <div :class="['cases-titles-btn', activeCase === 4 ? 'active' : '']" @click="activateCase(4, 'polls')">
              <p>Polls</p>
            </div>
          </div>

          <div class="cases-images">
            <div class="cases-images-inner">
              <div :class="['cases-image', activeCase === 0 ? 'active' : '']">
                <img src="./assets/img/cases/cases-0.png" alt="">
              </div>
              <div :class="['cases-image', activeCase === 1 ? 'active' : '']">
                <img src="./assets/img/cases/cases-1.png" alt="">
              </div>
              <div :class="['cases-image', activeCase === 2 ? 'active' : '']">
                <img src="./assets/img/cases/cases-2.png" alt="">
              </div>
              <div :class="['cases-image', activeCase === 3 ? 'active' : '']">
                <img src="./assets/img/cases/cases-3.png" alt="">
              </div>
              <div :class="['cases-image', activeCase === 4 ? 'active' : '']">
                <img src="./assets/img/cases/cases-4.png" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="plans-section container-fluid" id="plans">
    <div class="container" data-aos="fade">
      <div class="plans">
        <h2 class="plans-header">Ready to start with <span>Zerek.ai</span>?</h2>
        <p class="platform-text hide-tablet hide-desktop mt-8">Customer Data Platform Built for Mobile Banks</p>
        <div class="plans-cards">
          <div class="plans-card">
            <div class="plans-card-icon flex flex-row flex-align-items-center flex-justify-content-center">
              <i class="star"></i>
              <i class="star"></i>
              <i class="star"></i>
              <i class="star"></i>
              <i class="star"></i>
            </div>
            <h3 class="plans-card-header">Enterprise On-premises</h3>
            <div class="plans-card-info">
              <ul class="plans-card-list">
                <li class="plans-card-list-item"> Customer Data Platform</li>
                <li class="plans-card-list-item"> Personalization mechanism</li>
                <li class="plans-card-list-item"> Analytics</li>
                <li class="plans-card-list-item"> Management </li>
                <li class="plans-card-list-item"> No Code segmentation </li>
                <li class="plans-card-list-item"> 30 communication channels </li>
                <li class="plans-card-list-item"> Android, iOS, Web </li>
              </ul>
              <div class="flex flex-row flex-align-items-center flex-justify-content-center">
                <button class="primary hide-mobile" @click="toggleModal('ready_to_start')">
                  Request Demo
                </button>
                <button class="secondary secondary-white hide-tablet hide-desktop" @click="toggleModal('ready_to_start')">
                  Request Demo
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="contact container-fluid">
    <div class="container" data-aos="fade">
      <div class="contact-box flex flex-column flex-align-items-center">
        <h4 class="contact-box-header">Ready to engage customers with <span>Zerek</span>.ai</h4>
        <p class="contact-box-text">Feel free to drop us a line</p>
        <i class="arrow-down"></i>
        <div class="contact-box-form">
          <button class="contact-box-btn" @click="toggleModal('ready_to_engage')">Request Demo</button>
        </div>
      </div>
    </div>
  </section>

  <Footer />

  <transition name="modal">
    <Modal v-if="showModal" @close="toggleModal()"></Modal>
  </transition>
</template>

<script>
import Header from './components/Header'
import Footer from './components/Footer'
import Modal from './components/Modal'
import { event } from 'vue-gtag'
import AOS from 'aos'
import 'aos/dist/aos.css'
// import Glide from '@glidejs/glide'

export default {
  name: 'App',
  components: {
    Header,
    Footer,
    Modal
  },
  data() {
    return {
      active: 'customerSeg',
      isAnimationMobile: false,
      elementsRefs: {
        customerSeg: null,
        omnichannel: null,
        creativeEditor: null,
        customerData: null,
        aiBanking: null,
        analytics: null,
      },
      activeCase: 0,
      reviewsControl: null,
      plansControl: null,
      showModal: false,
      bannerIdx: 0,
      activeBanner: 'front',
      homeImages: [
        {
          id: 1,
          url: 'home-1.png',
          infoUrl: 'info-1.png',
          text: 'Y.O BOY’S PAGE',
          checked: true,
        },
        {
          id: 2,
          url: 'home-2.png',
          infoUrl: 'info-2.png',
          text: 'Y.O STUDENT’S PAGE',
          checked: false
        },
        {
          id: 3,
          url: 'home-3.png',
          infoUrl: 'info-3.png',
          text: 'Y.O LADY’S PAGE',
          checked: false
        },
        {
          id: 4,
          url: 'home-4.png',
          infoUrl: 'info-4.png',
          text: 'Y.O GENT’S BANK',
          checked: false
        },
      ],
      section: '',
      bannerInterval: null,
      logoCircle: null,
      curve1: null,
      curve2: null,
      curve3: null,
      curve4: null,
      curve5: null,
      curve6: null,
      curve7: null,
      curve8: null,
      curve9: null,
      dot1: null,
      dot2: null,
      dot3: null,
      dot4: null,
      dot5: null,
      dot6: null,
      dot7: null,
      dot8: null,
      dot9: null
    }
  },
  setup() {
    event('page_view', { method: 'Google' })
  },
  methods: {
    moveBackgroundIcons(event) {
      document.querySelectorAll(".banner-main-icon").forEach((shift) => {
        const position = shift.getAttribute("value");
        const x = (window.innerWidth - event.pageX * position) / 90;
        const y = (window.innerHeight - event.pageY * position) / 90;

        shift.style.transform = `translateX(${x}px) translateY(${y}px)`;
      });
    },

    getImagePath(filename) {
      return require('./assets/img/home/' + filename);
    },

    changeBannerImg() {
      this.bannerIdx > 4 ? this.bannerIdx = 0 : this.bannerIdx++;

      if (this.homeImages[0].checked) {
        this.homeImages[0].checked = false;
        this.homeImages[1].checked = true;
        this.homeImages[2].checked = false;
        this.homeImages[3].checked = false;
      } else if (this.homeImages[1].checked) {
        this.homeImages[0].checked = false;
        this.homeImages[1].checked = false;
        this.homeImages[2].checked = true;
        this.homeImages[3].checked = false;
      } else if (this.homeImages[2].checked) {
        this.homeImages[0].checked = false;
        this.homeImages[1].checked = false;
        this.homeImages[2].checked = false;
        this.homeImages[3].checked = true;
      } else if (this.homeImages[3].checked) {
        this.homeImages[0].checked = true;
        this.homeImages[1].checked = false;
        this.homeImages[2].checked = false;
        this.homeImages[3].checked = false;
      }
    },

    isBannerActive(idx) {
      return idx === this.bannerIdx;
    },

    activateCase(id, value) {
      this.activeCase = id;
      event('use_cases_' + value, {method: 'Google', item: 'use_cases'});
    },

    makeImageActive(section) {
      this.active = section;
      event('feature_' + section, {method: 'Google', item: 'key_features'});
    },

    toggleModal(block) {
      if (block) {
        event('request_demo_from_' + block, {method: 'Google', item: 'contact_us'});
      }
      this.showModal = !this.showModal;
    },

    init(sprite, track) {
      this.sprite = document.getElementById(sprite);
      this.track = document.getElementById(track);
    },

    // Put the dot on its spot
    move(u) {
      const p1 = this.curve1.getPointAtLength(u * this.curve1.getTotalLength());

      if (!this.isAnimationMobile) {
        this.dot1.setAttribute('transform', `translate(${p1.x}, ${p1.y})`);
      } else {
        this.dot1.setAttribute('transform', `translate(${p1.x}, ${p1.y - 3})`);
      }
      const p2 = this.curve2.getPointAtLength(u * this.curve2.getTotalLength());

      if (!this.isAnimationMobile) {
        this.dot2.setAttribute('transform', `translate(${p2.x}, ${p2.y})`);
      } else {
        this.dot2.setAttribute('transform', `translate(${p2.x - 1}, ${p2.y})`);
      }
      const p3 = this.curve3.getPointAtLength(u * this.curve3.getTotalLength());

      if (!this.isAnimationMobile) {
        this.dot3.setAttribute('transform', `translate(${p3.x}, ${p3.y})`);
      } else {
        this.dot3.setAttribute('transform', `translate(${p3.x - 117}, ${p3.y - 3})`);
      }

      const p4 = this.curve4.getPointAtLength(u * this.curve4.getTotalLength());
      if (!this.isAnimationMobile) {
        this.dot4.setAttribute('transform', `translate(${p4.x - 246}, ${p4.y})`);
      } else {
        this.dot4.setAttribute('transform', `translate(${p4.x}, ${p4.y})`);
      }

      const p5 = this.curve5.getPointAtLength(u * this.curve5.getTotalLength());

      if (!this.isAnimationMobile) {
        this.dot5.setAttribute('transform', `translate(${p5.x - 492}, ${p5.y})`);
      } else {
        this.dot5.setAttribute('transform', `translate(${p5.x - 68}, ${p5.y})`);
      }
      setTimeout(() => this.rotateLogo(), 2000);
      setTimeout(() => this.moveBottom(u), 4000);
    },

    rotateLogo() {
      this.logoCircle.classList.add('rotate');
      let bb = this.logoCircle.getBBox()
      let c = {};
      c.x = bb.x + bb.width / 2;
      c.y = bb.y + bb.height / 2;
      this.logoCircle.setAttribute('style', `transform-origin:${c.x}px ${c.y}px`)
      setTimeout(() => this.logoCircle.classList.remove('rotate'), 2000);
    },

    moveBottom(u) {
      const p6 = this.curve6.getPointAtLength(u * this.curve6.getTotalLength());
      if (!this.isAnimationMobile) {
        this.dot6.setAttribute('transform', `translate(${p6.x - 462}, ${p6.y + 14})`);
      } else {
        this.dot6.setAttribute('transform', `translate(${p6.x}, ${p6.y + 14})`);
      }
      const p7 = this.curve7.getPointAtLength(u * this.curve7.getTotalLength());
      if (!this.isAnimationMobile) {
        this.dot7.setAttribute('transform', `translate(${p7.x - 157}, ${p7.y + 14})`);
      } else {
        this.dot7.setAttribute('transform', `translate(${p7.x - 1}, ${p7.y + 14})`);
      }

      const p8 = this.curve8.getPointAtLength(u * this.curve8.getTotalLength());
      this.dot8.setAttribute('transform', `translate(${p8.x}, ${p8.y + 14})`);

      const p9 = this.curve9.getPointAtLength(u * this.curve9.getTotalLength());
      this.dot9.setAttribute('transform', `translate(${p9.x}, ${p9.y + 14})`);
    },

    start(duration) {
      this.duration = duration;
      this.tZero = Date.now();

      requestAnimationFrame(() => this.run());
    },

    run() {
      let u = Math.min((Date.now() - this.tZero) / this.duration, 1);

      if (u < 1) {
        // Keep requesting frames, till animation is ready
        requestAnimationFrame(() => this.run());
      } else {
        this.onFinish();
      }
      this.move(u)
    },

    onFinish() {
      // Schedule the animation to restart
      setTimeout(() => this.start(this.duration), 5000);
    }
  },
  mounted: function() {
    AOS.init({
      duration: 1000,
      disable: 'mobile'
    });
    if (window.screen.width < 1210) {
      this.isAnimationMobile = true;
    }

    AOS.refreshHard();

    this.elementsRefs = {
        customerSeg: this.$refs.customerSeg,
        omnichannel: this.$refs.omnichannel,
        creativeEditor: this.$refs.creativeEditor,
        customerData: this.$refs.customerData,
        aiBanking: this.$refs.aiBanking,
        analytics: this.$refs.analytics
    }

    let banner = document.getElementById('banner');

    if (this.isAnimationMobile) {
      const allDot1 = document.querySelectorAll('[id=dot1]');
      this.dot1 = allDot1[allDot1.length-1];
    } else {
      this.dot1 = document.getElementById('dot1');
    }

    if (this.isAnimationMobile) {
      const allDot2 = document.querySelectorAll('[id=dot2]');
      this.dot2 = allDot2[allDot2.length-1];
    } else {
      this.dot2 = document.getElementById('dot2');
    }

    if (this.isAnimationMobile) {
      const allDot3 = document.querySelectorAll('[id=dot3]');
      this.dot3 = allDot3[allDot3.length-1];
    } else {
      this.dot3 = document.getElementById('dot3');
    }

    if (this.isAnimationMobile) {
      const allDot4 = document.querySelectorAll('[id=dot4]');
      this.dot4 = allDot4[allDot4.length-1];
    } else {
      this.dot4 = document.getElementById('dot4');
    }

    if (this.isAnimationMobile) {
      const allDot5 = document.querySelectorAll('[id=dot5]');
      this.dot5 = allDot5[allDot5.length-1];
    } else {
      this.dot5 = document.getElementById('dot5');
    }

    if (this.isAnimationMobile) {
      const allDot6 = document.querySelectorAll('[id=dot6]');
      this.dot6 = allDot6[allDot6.length-1];
    } else {
      this.dot6 = document.getElementById('dot6');
    }

    if (this.isAnimationMobile) {
      const allDot7 = document.querySelectorAll('[id=dot7]');
      this.dot7 = allDot7[allDot7.length-1];
    } else {
      this.dot7 = document.getElementById('dot7');
    }

    if (this.isAnimationMobile) {
      const allDot8 = document.querySelectorAll('[id=dot8]');
      this.dot8 = allDot8[allDot8.length-1];
    } else {
      this.dot8 = document.getElementById('dot8');
    }

    if (this.isAnimationMobile) {
      const allDot9 = document.querySelectorAll('[id=dot9]');
      this.dot9 = allDot9[allDot9.length-1];
    } else {
      this.dot9 = document.getElementById('dot9');
    }

    if (this.isAnimationMobile) {
      const allCurve1 = document.querySelectorAll('[id=curve1]');
      this.curve1 = allCurve1[allCurve1.length-1];
    } else {
      this.curve1 = document.getElementById('curve1');
    }

    if (this.isAnimationMobile) {
      const allCurve2 = document.querySelectorAll('[id=curve2]');
      this.curve2 = allCurve2[allCurve2.length-1];
    } else {
      this.curve2 = document.getElementById('curve2');
    }

    if (this.isAnimationMobile) {
      const allCurve3 = document.querySelectorAll('[id=curve3]');
      this.curve3 = allCurve3[allCurve3.length-1];
    } else {
      this.curve3 = document.getElementById('curve3');
    }

    if (this.isAnimationMobile) {
      const allCurve4 = document.querySelectorAll('[id=curve4]');
      this.curve4 = allCurve4[allCurve4.length-1];
    } else {
      this.curve4 = document.getElementById('curve4');
    }

    if (this.isAnimationMobile) {
      const allCurve5 = document.querySelectorAll('[id=curve5]');
      this.curve5 = allCurve5[allCurve5.length-1];
    } else {
      this.curve5 = document.getElementById('curve5');
    }

    if (this.isAnimationMobile) {
      const allCurve6 = document.querySelectorAll('[id=curve6]');
      this.curve6 = allCurve6[allCurve6.length-1];
    } else {
      this.curve6 = document.getElementById('curve6');
    }

    if (this.isAnimationMobile) {
      const allCurve7 = document.querySelectorAll('[id=curve7]');
      this.curve7 = allCurve7[allCurve7.length-1];
    } else {
      this.curve7 = document.getElementById('curve7');
    }

    if (this.isAnimationMobile) {
      const allCurve8 = document.querySelectorAll('[id=curve8]');
      this.curve8 = allCurve8[allCurve8.length-1];
    } else {
      this.curve8 = document.getElementById('curve8');
    }

    if (this.isAnimationMobile) {
      const allCurve9 = document.querySelectorAll('[id=curve9]');
      this.curve9 = allCurve9[allCurve9.length-1];
    } else {
      this.curve9 = document.getElementById('curve9');
    }

    this.logoCircle = document.getElementById('logo');

    if (this.isAnimationMobile) {
      const allLogo = document.querySelectorAll('[id=logo]');
      this.logoCircle = allLogo[allLogo.length-1];
    } else {
      this.logoCircle = document.getElementById('logo');
    }

    banner.addEventListener('mousemove', this.moveBackgroundIcons);
    this.bannerInterval = setInterval(this.changeBannerImg, 3000);

    // start animation
    this.start(2000);
  },
  unmounted: function() {
    window.removeEventListener('mousemove', this.moveBackgroundIcons);
    clearInterval(this.bannerInterval);
  }
}
</script>

